<template>
    <button
        class="menu-item"
        :class="{ 'is-active': isActive ? isActive(): null }"
        @click="action"
        :title="title"
    >
        <custom-icon :icon="icon" />
    </button>
</template>

<script>
import CustomIcon from '@/components/TipTap/CustomIcon.vue';

export default {
    components: {
        CustomIcon,
    },
    props: {
        icon: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        action: {
            type: Function,
            required: true,
        },
        isActive: {
            type: Function,
            default: null,
        },
    },
}
</script>